<template>
  <Dialog
    v-model:visible="isVisible"
    modal
    :closable="true"
    class="w-full max-w-md"
    @hide="$emit('close')"
  >
    <template #header>
      <div class="flex items-center gap-3">
        <i class="fas fa-lock text-red-500 text-xl"></i>
        <span class="font-semibold text-lg">Permission Denied</span>
      </div>
    </template>

    <div class="flex flex-col items-center gap-4 py-4 text-center">
      <div class="flex items-center justify-center w-16 h-16 rounded-full bg-red-100">
        <i class="fas fa-ban text-red-500 text-3xl"></i>
      </div>
      <p v-if="title" class="font-semibold text-gray-900">{{ title }}</p>
      <p class="text-gray-700">{{ message }}</p>
    </div>

    <template #footer>
      <div class="flex justify-end">
        <Button label="Close" @click="isVisible = false" />
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { computed } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: "You don't have permission to perform this action.",
  },
  title: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['close', 'update:visible']);

const isVisible = computed({
  get: () => props.visible,
  set: (value) => {
    emit('update:visible', value);
    if (!value) emit('close');
  },
});
</script>
